import React from "react";
import PropTypes from "prop-types";
import NavigationLink from "./NavigationLink";
import { Icon } from "best-common-react";
import TrophyIcon from "../../assets/wbc-trophy.svg";

const IconNavigationLink = ({ to, useTrophyIcon, icon, tooltip, toggleMobileNav, ...rest }) => {
  return (
    <NavigationLink to={to} tooltip={tooltip} toggleMobileNav={toggleMobileNav} {...rest}>
      {useTrophyIcon ? <img src={TrophyIcon} alt="navigation" height="24px" width="auto" /> : <Icon iconName={icon} />}
    </NavigationLink>
  );
};

IconNavigationLink.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  toggleMobileNav: PropTypes.bool.isRequired,
  tooltip: PropTypes.string,
  useTrophyIcon: PropTypes.bool
};

IconNavigationLink.defaultProps = {
  tooltip: null
};

export default IconNavigationLink;
